import { TableERP } from "@finanedi.es/storybook"
import { useQuery } from "@tanstack/react-query"
import { getAsientoContableModelo111 } from "api/AsientoContable.service"
import { PERIODO } from "api/Types/Periodo"
import { Dropdown } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { HandleTabs } from "../../DetalleImpuestos"
import { RedirectParams } from "../constants"
import { MODELO_111_COLUMNS } from "./Modelo111Columns"

export const Modelo111 = ({
  props: { year, handleYearSelection, yearsOptionList },
}: {
  props: HandleTabs
}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const navigate = ({ route, periodo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      year,
    })
  }
  const fetchModelo111 = async () => {
    const data = await getAsientoContableModelo111({
      Anyo: year.selectedYear,
      Periodo: PERIODO.TRIMESTRAL,
    })
    return data
  }

  const { data, isLoading } = useQuery({
    queryKey: ["modelo111", year.selectedYear],
    queryFn: fetchModelo111,
    select: (response) => {
      const periodos = response?.periodos ?? []
      return [
        ...periodos,
        {
          periodo: undefined,
          totalPercepcion: periodos.reduce(
            (acc, curr) => acc + (curr.totalPercepcion ?? 0),
            0
          ),
          totalPerceptores: periodos.reduce(
            (acc, curr) => acc + (curr.totalPerceptores ?? 0),
            0
          ),
          totalRetencion: periodos.reduce(
            (acc, curr) => acc + (curr.totalRetencion ?? 0),
            0
          ),
        },
      ]
    },
    refetchOnWindowFocus: true,
  })

  return (
    <>
      <div className='tw-py-4'>
        <div className='tw-rounded-t-xl tw-flex tw-bg-simple-10 tw-justify-between tw-items-center '>
          <p className='tw-py-5 tw-pl-6 tw-m-0 tw-text-lg tw-font-medium'>
            {t("taxSummary.tableTitle111")}
          </p>
          <Dropdown
            id='rangosFechaIvaImpuesto'
            name='rangosFechaivaImpuesto'
            className='tw-rounded-md tw-mr-6'
            value={year.selectedYear}
            options={yearsOptionList}
            onChange={handleYearSelection}
          />
        </div>
        <TableERP
          columns={MODELO_111_COLUMNS(t, navigate, year.selectedYear)}
          className='tw-h-full tw-min-h-60'
          rowClassName={(rowData) => {
            return rowData.periodo ? "" : "tw-font-medium !tw-bg-gray-100"
          }}
          columnResizeMode='expand'
          value={data}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          size='small'
          loading={isLoading}
        />
      </div>
    </>
  )
}
